type EpisodeDates = {
  dateAiring?: string;
  datePublished?: string;
};

export function resolveEpisodeDate(item: EpisodeDates) {
  return item.dateAiring || item.datePublished;
}
